import { render } from "./VisitDashboard.vue?vue&type=template&id=4b8cac78&scoped=true"
import script from "./VisitDashboard.vue?vue&type=script&lang=js"
export * from "./VisitDashboard.vue?vue&type=script&lang=js"

import "./VisitDashboard.vue?vue&type=style&index=0&id=4b8cac78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8cac78"]])

export default __exports__